<template>
    <router-link v-if="$router.userHasPermission(item)" 
                 tag="div" 
                 class="sidenav-item" 
                 :class="item.children ? {active: isMenuActive(item.path), disabled: disabled, open: isMenuOpen(item.path)} : {active: isMenuActive(item.path), disabled: disabled}"
                 :to="!item.children ?item.path: ''"
                 :replace="!item.children ?replace: ''"
                 :append="!item.children ?append: ''"
                 :exact="!item.children ?true: ''"
                 :event="!item.children ?event: ''">
            <a v-if="item.children" href="javascript:void(0)" class="sidenav-link sidenav-toggle" :class="linkClass">
                <i class="sidenav-icon" v-if="item.icon" :class="item.icon"></i>
                <div>{{item.title}}</div>
                <div v-if="badge" class="pl-1 ml-auto"><div class="badge" :class="badgeClass">{{badge}}</div></div>
            </a>
            <div v-if="item.children" class="sidenav-menu">
                <core-Menu v-for="child in item.children.filter(p => p.menu)"
                           :item="child">
                </core-Menu>
            </div>
            <a v-if="!item.children" class="sidenav-link" :class="linkClass">
                <i class="sidenav-icon" v-if="item.icon" :class="item.icon"></i>
                <div>{{item.title}}</div>
                <div v-if="badge" class="pl-1 ml-auto"><div class="badge" :class="badgeClass">{{badge}}</div></div>
            </a>
    </router-link>
</template>

<script>
    export default {
        name: 'sidenav-menu',
        props: {
            item: Object,
            linkClass: {
                type: String,
                default: ''
            },
            badge: {
                default: null
            },
            badgeClass: {
                type: String,
                default: ''
            },
            disabled: {
                type: Boolean,
                default: false
            },

            //router props
            replace: {
                type: Boolean,
                default: false
            },
            append: {
                type: Boolean,
                default: false
            },
            event: null,
            orientation: {
                type: String,
                default: 'vertical'
            }
        },

        methods: {
            isMenuActive(url) {
                return this.$route.path.indexOf(url) === 0
            },
            isMenuOpen(url) {
                return (
                    this.$route.path.indexOf(url) === 0 && this.orientation !== 'horizontal'
                )
            }
        }
    }
</script>
